import { render, staticRenderFns } from "./MobileMajorCat.vue?vue&type=template&id=080c5a0b&scoped=true"
import script from "./MobileMajorCat.vue?vue&type=script&lang=js"
export * from "./MobileMajorCat.vue?vue&type=script&lang=js"
import style0 from "./MobileMajorCat.vue?vue&type=style&index=0&id=080c5a0b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c5a0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080c5a0b')) {
      api.createRecord('080c5a0b', component.options)
    } else {
      api.reload('080c5a0b', component.options)
    }
    module.hot.accept("./MobileMajorCat.vue?vue&type=template&id=080c5a0b&scoped=true", function () {
      api.rerender('080c5a0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileMajorCat.vue"
export default component.exports